export default {
  success: 'toastSuccess',
  warning: 'toastWarning',
  error: 'toastError',
  info: 'toastInfo'
};
